// These unmodified, bundled fonts are used by both DOM editing and PDF export.
// No network font service or viewer-specific substitution is needed.
export function editorFontFamily(family = 'Helvetica') {
  return /Courier|Mono/.test(family) ? 'LiberationMono'
    : /Times|Slab|Serif/.test(family) ? 'LiberationSerif' : 'LiberationSans';
}
const bytesCache = new Map();
export async function embedEditorFont(doc, styles, cache) {
  const family = editorFontFamily(styles.fontFamily);
  const variant = styles.bold && styles.italic ? 'BoldItalic' : styles.bold ? 'Bold' : styles.italic ? 'Italic' : 'Regular';
  const key = `${family}-${variant}`;
  cache.editor ||= {};
  if (cache.editor[key]) return cache.editor[key];
  if (!cache.fontkit) {
    doc.registerFontkit((await import('@pdf-lib/fontkit')).default);
    cache.fontkit = true;
  }
  if (!bytesCache.has(key)) bytesCache.set(key, fetch(`/fonts/editor/${key}.ttf`).then(async (r) => {
    if (!r.ok) throw new Error(`Could not load the ${family} font`);
    return new Uint8Array(await r.arrayBuffer());
  }).catch((err) => { bytesCache.delete(key); throw err; }));
  const font = await doc.embedFont(await bytesCache.get(key), { subset: true });
  cache.editor[key] = font;
  return font;
}
